export default (ctx, inject) => {
  inject('spinner', {
    show() {
      document.body.classList.add('loading');
    },
    hide() {
      document.body.classList.remove('loading');
    },
  });
};
